import register from '@kpsys/angularjs-register';
import apidocsRoutes from './apidocs.routes';

export default register('portaro.features.apidocs')
    .config(apidocsRoutes)
    .name();
